// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--eKw+G";
export var root = "Layout-module--root--adWki";